import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';

export const useIsMobile = (themeBreakpoint = 'sm') => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(themeBreakpoint));

  return isMobile;
};
